import React, { useEffect, useState } from 'react';

import doLog from '../../../common/log';
import { resetUrl } from '../../../common/reset-image';

import './index.less';

export default function LcpVideo(props: {
  item: Partial<ImageInterface>;
  abtest: DetailTypes.Abtest;
  renderSkuImg: boolean;
}) {
  const { item, abtest, renderSkuImg } = props || {};
  const [visible, setVisible] = useState(false);

  // 创建一个MutationObserver实例
  const observer = new MutationObserver(mutationsList => {
    // 当节点发生变化时执行的回调函数
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const videoElement = document.querySelector('#main-video video');
        if (videoElement) {
          videoElement.addEventListener('loadedmetadata', () => {
            setTimeout(() => {
              setVisible(true);
            }, 3 * 1024);
          });
        }
      }
    }
  });
  useEffect(() => {
    const targetNode = document.getElementById('main-video');

    const config = { childList: true };
    // 开始观察目标节点
    if (targetNode) observer.observe(targetNode, config);
  }, []);

  // 此处为了解决LCP指定video标签，用img标签替代
  return (
    <>
      {!visible && item.videoCoverUrl && !renderSkuImg && (
        <>
          <img
            onClick={() => {
              setVisible(true);
            }}
            style={{
              cursor: 'pointer',
            }}
            src={
              resetUrl(item.videoCoverUrl + '', '720', 'q50') ||
              'data:image/png;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='
            }
          />

          <div className="react-dove-playButton react-dove-bigPlay unset">
            <div className="react-dove-playButton-wapper">
              <span role="img" className="anticon react-dove-icon react-dove-playButton-arrow">
                <div className="play-triangle"></div>
              </span>
            </div>
          </div>
        </>
      )}
      <div
        id="main-video"
        style={{
          zIndex: 0,
          display: visible && item.type === 'video' && !renderSkuImg ? 'block' : 'none',
        }}
        onClick={() => {
          doLog('/sc.details.main_video_play');
        }}
      ></div>
    </>
  );
}
